module.exports = __webpack_public_path__ + "static/BearbatLogo-6019464ebe411d965aca54bd4a8e6355.svg";